import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeleteDiscardDialogComponent } from '../delete-discard-dialog/delete-discard-dialog.component';

@Component({
  selector: 'app-different-grade-dialog',
  templateUrl: './different-grade-dialog.component.html',
  styleUrls: ['./different-grade-dialog.component.scss']
})
export class DifferentGradeDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DifferentGradeDialogComponent>,
  ) { }

  ngOnInit(): void {
    
  }

  onProceed(){
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
